import { Component, Input } from '@angular/core';
import { FooterComponent } from '../components/shared/footer/footer';
import { HeaderComponent } from '../components/shared/header/header';
import { PopularSectionsComponent } from '../components/shared/popular-sections/popular-sections';

@Component({
  selector: 'allas-main-layout',
  imports: [HeaderComponent, FooterComponent, PopularSectionsComponent],
  template: `
    <allas-header />
    <main class="flex flex-col gap-4 min-h-[300px]">
      <ng-content></ng-content>
    </main>
    @if(showPopularSections) {
    <allas-popular />
    }
    <allas-footer />
  `,
})
export class MainLayout {
  @Input() showPopularSections = false;
  @Input() showNewsletter = false;
}
